import "core-js/stable";
import "regenerator-runtime/runtime";

import * as React from "react";
import * as ReactDOM from "react-dom";

import { ZoningWorkbench } from "@zoning/components/ZoningWorkbench";

ReactDOM.render(<ZoningWorkbench review={false} />, document.getElementById("root") as HTMLElement);
